<ng-container screenAnalytics="notice-acknowledgements">
    <div class="modal-header no-icon">
        <h3 class="modal-title">
            All Acknowledgements For {{ notice.subject }}
        </h3>
        <button
            type="button"
            aria-label="Close"
            class="close"
            (click)="onClose()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body inner-container no-footer">
        <div class="modal-body-content container-scroll">
            <div class="table-container">
                <static-table
                    [availableColumns]="availableColumns"
                    [tableData]="rows"
                    [tableConfig]="tableConfig"
                >
                </static-table>
                <ngx-loading [show]="working"></ngx-loading>
            </div>
        </div>
    </div>
</ng-container>
